// extracted by mini-css-extract-plugin
export default {"formError":"form-error_formError__uj8m4"};